import React from "react";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { Controller } from "react-hook-form";

export default function AutocompleteController({
  onChange,
  control,
  ...props
}) {
  return (
    <Controller
      as={
        <Autocomplete
          {...props.Values}
          id={props.id}
          testid={props.testid}
          autoComplete={true}
          autoSelect={false}
          name={props.name}
          autoHighlight={true}
          error={props.error}
          required={props.required}
          defaultValue={props.defaultValue}
          disabled={props.disabled}
          onInputChange={(event, value) => {
            if (props.handletextChange) {
              props.handletextChange(value);
            }
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label={props.label}
              error={props.error}
              required={props.required}
              placeholder={props.placeholder}
              name={props.name}
              disabled={props.disabled}
              margin="normal"
              variant="outlined"
              size="small"
            />
          )}
        />
      }
      onChange={([, data]) => {
        try {
          props.getValueChanged(data);
        } catch {
          console.log("getvalueChnaged is not defined");
        }

        return data;
      }}
      name={props.name}
      rules={props.rules}
      control={control}
      onBlur={props.onBlur}
    />
  );
}
